<template lang="pug">
  .privacy-policy(v-if="privacyPolicy")
    .privacy-policy__border.privacy-policy__border--top
    .privacy-policy__border.privacy-policy__border--right
    .privacy-policy__border.privacy-policy__border--bottom
    .privacy-policy__border.privacy-policy__border--left
    .privacy-policy__corner.privacy-policy__corner--tl
    .privacy-policy__corner.privacy-policy__corner--tr
    .privacy-policy__corner.privacy-policy__corner--bl
    .privacy-policy__corner.privacy-policy__corner--br
    .privacy-policy__decor-top
    .privacy-policy__decor-bottom
    .privacy-policy__title(v-if="h1") {{h1}}
    .privacy-policy__content
      .privacy-policy__text(v-if='privacyPolicy.text', v-html="privacyPolicy.text")

</template>

<script>
import EventBus from '@/eventBus';

//import '@/components/privacyPolicy/privacyPolicy.styl';
import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';

export default {
  name: 'PrivacyPolicy',

  mixins: [AjaxHelpersVue],

  data() {
    return {
      privacyPolicy: null,
      ps: null
    }
  },

  components: {},

  created() {
    // Загрузка данных для страницы
    EventBus.$on('loadPrivacyPolicyPage', params => {
      this.request(params.url);
    });
  },

  methods: {
    request(url) {
      this.req('PolicyPage:getPolicyPage', {url}, res => {
        if(this.checkProperty(res.content)) {
          this.privacyPolicy = res.content;

          this.$nextTick(() => {
            this.initScroll();
          });
        }
      }, 'privacy-policy');
    },

    initScroll() {
      if(this.ps === null) {
        this.ps = new PerfectScrollbar('.privacy-policy__content', {
          wheelSpeed: 0.3,
          wheelPropagation: true,
          minScrollbarLength: 25,
          maxScrollbarLength: 25
        });
      }
      else {
        this.ps.update();
      }
    },
  }
}
</script>
